(function () {
  var fieldNames = {
    locker_id: 'BOX NOW Locker ID',
    locker_name: 'BOX NOW Locker Name',
    locker_address: 'BOX NOW Locker Address',
    locker_postal_code: 'BOX NOW Locker Postal Code'
  };

  function getRoot() {
    return document.querySelector('[data-boxnow-cart-picker]');
  }

  function getCartRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function getText(root, key, fallback) {
    return root ? root.getAttribute('data-boxnow-' + key) || fallback : fallback;
  }

  function getSelection(selected) {
    selected = selected || {};

    return {
      locker_id: selected.boxnowLockerId || '',
      locker_name: selected.boxnowLockerName || selected.boxnowLockerTitle || selected.boxnowLockerAddressLine1 || '',
      locker_address: selected.boxnowLockerAddressLine1 || '',
      locker_postal_code: selected.boxnowLockerPostalCode || ''
    };
  }

  function setMessage(root, message, isError) {
    var status = root.querySelector('[data-boxnow-status]');
    var error = root.querySelector('[data-boxnow-error]');

    if (status) {
      status.textContent = isError ? '' : message;
      status.hidden = Boolean(isError || !message);
    }

    if (error) {
      error.textContent = isError ? message : '';
      error.hidden = !isError;
    }
  }

  function setFields(root, values) {
    Object.keys(values).forEach(function (key) {
      var field = root.querySelector('[data-boxnow-field="' + key + '"]');

      if (field) {
        field.value = values[key] || '';
      }
    });
  }

  function renderSelection(root, values) {
    var selectedBox = root.querySelector('[data-boxnow-selected]');
    var selectedName = root.querySelector('[data-boxnow-selected-name]');
    var selectedAddress = root.querySelector('[data-boxnow-selected-address]');
    var openButton = root.querySelector('[data-boxnow-open]');

    if (selectedName) {
      selectedName.textContent = values.locker_name || getText(root, 'selected-label', 'Selected BOX NOW locker');
    }

    if (selectedAddress) {
      selectedAddress.textContent = [values.locker_address, values.locker_postal_code].filter(Boolean).join(', ');
    }

    if (selectedBox) {
      selectedBox.hidden = !values.locker_id;
    }

    if (openButton && values.locker_id) {
      openButton.textContent = getText(root, 'change-label', 'Change BOX NOW locker');
    }
  }

  function saveToShopify(values) {
    var data = new FormData();

    Object.keys(fieldNames).forEach(function (key) {
      data.append('attributes[' + fieldNames[key] + ']', values[key] || '');
    });

    return fetch(getCartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data
    }).then(function (response) {
      return response.json();
    });
  }

  function save(selected) {
    var root = getRoot();
    var values = getSelection(selected);

    if (!root || !values.locker_id) {
      return Promise.resolve(false);
    }

    root.dataset.boxnowSaving = 'true';
    root.dataset.boxnowSaved = 'false';
    setFields(root, values);
    renderSelection(root, values);
    setMessage(root, getText(root, 'status-saving', 'Saving BOX NOW locker...'), false);

    return saveToShopify(values)
      .then(function (cart) {
        var savedLockerId = cart.attributes && cart.attributes[fieldNames.locker_id];

        window.BoxNowCartPickerLastSave = {
          attributes: values,
          cartAttributes: cart.attributes,
          saved: Boolean(savedLockerId)
        };

        root.dataset.boxnowSaving = 'false';
        root.dataset.boxnowSaved = savedLockerId ? 'true' : 'false';
        setMessage(
          root,
          savedLockerId
            ? getText(root, 'status-saved', 'BOX NOW locker saved.')
            : getText(root, 'error-not-saved', 'Shopify did not return the locker on the cart. Please try again.'),
          !savedLockerId
        );

        return Boolean(savedLockerId);
      })
      .catch(function (error) {
        window.BoxNowCartPickerLastError = error;
        root.dataset.boxnowSaving = 'false';
        root.dataset.boxnowSaved = 'false';
        setMessage(root, getText(root, 'error-save-failed', 'Shopify could not save the BOX NOW locker. Please try again.'), true);
        return false;
      });
  }

  function blockCheckout(event) {
    var root = getRoot();
    var checkout = event.target.closest && event.target.closest('button[name="checkout"], input[name="checkout"]');

    if (!root || !checkout) {
      return;
    }

    var lockerField = root.querySelector('[data-boxnow-field="locker_id"]');
    var hasLocker = lockerField && lockerField.value && root.dataset.boxnowSaved === 'true';

    if (hasLocker) {
      return;
    }

    setMessage(
      root,
      root.dataset.boxnowSaving === 'true'
        ? getText(root, 'error-wait', 'Please wait while your BOX NOW locker is saved.')
        : getText(root, 'error-select', 'Please select a BOX NOW locker before checkout.'),
      true
    );
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    event.preventDefault();
    event.stopPropagation();
  }

  function init() {
    var root = getRoot();
    var lockerField = root && root.querySelector('[data-boxnow-field="locker_id"]');

    if (!root) {
      return;
    }

    root.dataset.boxnowSaving = 'false';
    root.dataset.boxnowSaved = lockerField && lockerField.value ? 'true' : 'false';
    document.addEventListener('click', blockCheckout, true);

    if (window.BoxNowCartPickerPendingSelection) {
      save(window.BoxNowCartPickerPendingSelection);
      window.BoxNowCartPickerPendingSelection = null;
    }
  }

  window.BoxNowCartPicker = {
    save: save
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();